import { render, staticRenderFns } from "./PendingFixedPrices.vue?vue&type=template&id=6fd45094"
import script from "./PendingFixedPrices.vue?vue&type=script&lang=js"
export * from "./PendingFixedPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports